(function () {
  'use strict';

  var CART_API = '/cart.js';
  var CART_ADD_API = '/cart/add.js';
  var POLL_INTERVAL = 3000;
  var _cartCount = 0;
  /** Avoid double-fetch / double-listener when several sections load discount-tiers.js */
  var _didBindCartTierListeners = false;
  var _didPatchNetworkForTiers = false;

  async function fetchCartCount() {
    try {
      var res = await fetch(CART_API, { credentials: 'same-origin' });
      var data = await res.json();
      return data.item_count || 0;
    } catch (e) {
      return _cartCount;
    }
  }

  function parseTiers(el) {
    try {
      return JSON.parse(el.dataset.tiers || '[]');
    } catch (e) {
      return [];
    }
  }

  function computeTierState(count, tiers) {
    if (count === 0) return { activeTierIndex: -1, unlockedUpTo: -1 };

    var activeTierIndex = -1;
    var unlockedUpTo = -1;

    for (var i = 0; i < tiers.length; i++) {
      if (count >= tiers[i].qty) unlockedUpTo = i;
    }

    for (var j = 0; j < tiers.length; j++) {
      if (count < tiers[j].qty) {
        activeTierIndex = j;
        break;
      }
    }

    if (activeTierIndex === -1 && unlockedUpTo >= 0) {
      activeTierIndex = unlockedUpTo;
    }

    return { activeTierIndex: activeTierIndex, unlockedUpTo: unlockedUpTo };
  }

  /** Cart drawer tier strip: empty cart still shows next goal at qty 2. */
  function computeDrawerTierState(count, tiers) {
    var state = computeTierState(Math.max(count, 0), tiers);
    if (count === 0 && tiers.length) {
      state = { activeTierIndex: 0, unlockedUpTo: -1 };
    }
    return state;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  var DRAWER_SEG_CLASSES = [
    'cart-drawer-discount-tier__connector--past',
    'cart-drawer-discount-tier__connector--active-wing-left',
    'cart-drawer-discount-tier__connector--active-wing-right',
    'cart-drawer-discount-tier__connector--active-lead-full'
  ];

  function resetDrawerSegments(el) {
    el.querySelectorAll('[data-tier-seg]').forEach(function (seg) {
      DRAWER_SEG_CLASSES.forEach(function (c) {
        seg.classList.remove(c);
      });
    });
  }

  /**
   * Segments: optional `lead` before node 0, then numeric 0 … n-2 between circles.
   * Red “wings”: ~20% of bar at the active milestone (percent-based = reference look).
   */
  function applyDrawerSegments(el, activeTierIndex, tierCount, allComplete) {
    var nodes = tierCount || 4;
    var nSegs = nodes - 1;
    var lead = el.querySelector('[data-tier-seg="lead"]');

    resetDrawerSegments(el);

    function segByIndex(k) {
      return el.querySelector('[data-tier-seg="' + k + '"]');
    }

    if (allComplete) {
      if (lead) {
        lead.classList.add('cart-drawer-discount-tier__connector--past');
      }
      for (var i = 0; i < nSegs; i++) {
        var s = segByIndex(i);
        if (s) {
          s.classList.add('cart-drawer-discount-tier__connector--past');
        }
      }
      return;
    }

    var a =
      typeof activeTierIndex === 'number' ? activeTierIndex : -1;
    if (a < 0) {
      return;
    }

    if (lead) {
      if (a === 0) {
        lead.classList.add('cart-drawer-discount-tier__connector--active-lead-full');
      } else if (a >= 1) {
        lead.classList.add('cart-drawer-discount-tier__connector--past');
      }
    }

    for (var k = 0; k < nSegs; k++) {
      var sg = segByIndex(k);
      if (!sg) {
        continue;
      }

      if (a >= 2 && k <= a - 2) {
        sg.classList.add('cart-drawer-discount-tier__connector--past');
      }
      if (a >= 1 && k === a - 1) {
        sg.classList.add('cart-drawer-discount-tier__connector--active-wing-left');
      }
      if (a < nodes - 1 && k === a) {
        sg.classList.add('cart-drawer-discount-tier__connector--active-wing-right');
      }
    }
  }

  function setDrawerBanner(bannerEl, count, tiers, activeTierIndex, unlockedUpTo) {
    if (!bannerEl || !tiers.length) return;

    var last = tiers[tiers.length - 1];
    if (count >= last.qty) {
      bannerEl.innerHTML =
        'You\u2019re saving %' +
        escapeHtml(String(last.saving)) +
        '!';
      return;
    }

    if (activeTierIndex < 0) {
      bannerEl.innerHTML = '';
      return;
    }

    var next = tiers[activeTierIndex];
    if (!next || count >= next.qty) {
      bannerEl.innerHTML = '';
      return;
    }

    var needed = next.qty - count;
    var itemWord = needed === 1 ? 'item' : 'items';
bannerEl.innerHTML =
  'Add <span class="cart-drawer__discount-tier-banner-accent">' +
  escapeHtml(String(needed)) +
  '</span> more ' +
  itemWord +
  ' to save ' +
  escapeHtml(String(next.saving)) +
  '%!';
  }

  function updateCartDrawerTiers(el, count, tiers) {
    var bannerEl = el.querySelector('[data-cuft-drawer-tier-banner-text]');
    var drawerNodes = el.querySelectorAll('[data-cart-drawer-tier-node]');

    if (tiers.length && count >= tiers[tiers.length - 1].qty) {
      drawerNodes.forEach(function (nodeEl) {
        nodeEl.classList.remove('cart-drawer-discount-tier__node--active');
        nodeEl.classList.add('cart-drawer-discount-tier__node--complete');
      });
      applyDrawerSegments(el, 0, tiers.length, true);
      setDrawerBanner(bannerEl, count, tiers, -1, -1);
      return;
    }

    var state = computeDrawerTierState(count, tiers);
    var activeTierIndex = state.activeTierIndex;
    var unlockedUpTo = state.unlockedUpTo;

    el.querySelectorAll('[data-cart-drawer-tier-node]').forEach(function (nodeEl, i) {
      nodeEl.classList.remove(
        'cart-drawer-discount-tier__node--active',
        'cart-drawer-discount-tier__node--complete'
      );
      if (!tiers[i]) return;

      var isUnlocked = i < unlockedUpTo || (i === unlockedUpTo && i !== activeTierIndex);

      var isActive = i === activeTierIndex;

      if (isUnlocked) {
        nodeEl.classList.add('cart-drawer-discount-tier__node--complete');
      } else if (isActive) {
        nodeEl.classList.add('cart-drawer-discount-tier__node--active');
      }
    });

    applyDrawerSegments(el, activeTierIndex, tiers.length, false);

    setDrawerBanner(bannerEl, count, tiers, activeTierIndex, unlockedUpTo);
  }

  function buildNudge(count, tiers, activeTierIndex, unlockedUpTo) {
    if (count === 0 || activeTierIndex === -1) return '';

    var next = tiers[activeTierIndex];
    if (!next) return '';

    var current = unlockedUpTo >= 0 ? tiers[unlockedUpTo] : null;

    if (count >= next.qty) {
      return "You're saving " + next.saving + "%!";
    }

    var needed = next.qty - count;
    var prefix = current ? "You're saving " + current.saving + "% " : '';
    return prefix + 'Add ' + needed + ' more item for ' + next.saving + '% off';
  }

  function updateTierEl(el, count) {
    var tiers = parseTiers(el);
    if (!tiers.length) return;

    if (el.classList.contains('cuft-discount-tiers--cart-drawer')) {
      updateCartDrawerTiers(el, count, tiers);
      return;
    }

    var state = computeTierState(count, tiers);
    var activeTierIndex = state.activeTierIndex;
    var unlockedUpTo = state.unlockedUpTo;
    var tierEls = el.querySelectorAll('.cuft-tier[data-tier-qty]');

    tierEls.forEach(function (tierEl, i) {
      tierEl.classList.remove('cuft-tier--active', 'cuft-tier--unlocked');
      var qtyEl = tierEl.querySelector('.cuft-tier__qty');
      if (!qtyEl || !tiers[i]) return;

      var savingEl = tierEl.querySelector('.cuft-tier__saving');
      var isUnlocked = (i < unlockedUpTo) || (i === unlockedUpTo && i !== activeTierIndex);
      var isActive = (i === activeTierIndex);

      if (isUnlocked) {
        tierEl.classList.add('cuft-tier--unlocked');
        qtyEl.textContent = tiers[i].unlockedLabel || tiers[i].qty + ' Pack Unlocked!';
        if (savingEl) savingEl.hidden = true;
      } else {
        var needed = tiers[i].qty - count;
        var itemWord = needed <= 1 ? 'item' : 'items';
        qtyEl.textContent = 'Add ' + needed + ' ' + itemWord;
        if (savingEl) savingEl.hidden = false;
        if (isActive) tierEl.classList.add('cuft-tier--active');
      }
    });

    var nudgeEl = el.querySelector('[data-cuft-nudge]');
    if (nudgeEl) {
      nudgeEl.textContent = buildNudge(count, tiers, activeTierIndex, unlockedUpTo);
    }
  }

  function updateAllTiers(count) {
    _cartCount = count;
    document.querySelectorAll('[data-cuft-tiers]').forEach(function (el) {
      updateTierEl(el, count);
    });
  }

  async function refresh() {
    var count = await fetchCartCount();
    updateAllTiers(count);
  }

  function interceptCartRequests() {
    if (_didPatchNetworkForTiers) return;
    _didPatchNetworkForTiers = true;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var promise = originalFetch.apply(this, args);
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        promise.then(function () { setTimeout(refresh, 300); }).catch(function () {});
      }
      return promise;
    };

    var XHR = XMLHttpRequest.prototype;
    var origOpen = XHR.open;
    XHR.open = function (method, url) {
      this._cuftUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XHR.send;
    XHR.send = function () {
      if (this._cuftUrl && (
        this._cuftUrl.includes('/cart/add') ||
        this._cuftUrl.includes('/cart/change') ||
        this._cuftUrl.includes('/cart/update')
      )) {
        this.addEventListener('load', function () { setTimeout(refresh, 300); });
      }
      return origSend.apply(this, arguments);
    };
  }

  function bindCartEvents() {
    if (_didBindCartTierListeners) return;
    _didBindCartTierListeners = true;

    ['cart:updated', 'cart:change', 'cart:refresh', 'product:added', 'ajaxProduct:added'].forEach(function (evt) {
      document.addEventListener(evt, refresh);
    });
    interceptCartRequests();
    setInterval(refresh, POLL_INTERVAL);
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getCurrentProductColor() {
    var colorInput = document.querySelector('[name="options[Color]"], [name="options[color]"]');
    if (colorInput) return colorInput.value;

    var activeColorBtn = document.querySelector('.product-form__option--color .active, [data-option-name="Color"] .active, [data-option-name="color"] .active');
    if (activeColorBtn) return activeColorBtn.dataset.value || activeColorBtn.textContent.trim();

    return null;
  }

  function initCamiCard() {
    if (window.__cuftCamiCardInitDone) return;
    var card = document.querySelector('[data-cuft-cami]');
    if (!card) return;

    var variants = window.cuftCamiVariants || [];
    if (!variants.length) return;

    window.__cuftCamiCardInitDone = true;

    var selectedColor = variants[0].option1;
    var selectedSize = null;

    var swatches = card.querySelectorAll('[data-cuft-color]');
    var sizesContainer = card.querySelector('[data-cuft-cami-sizes]');
    var btn = card.querySelector('[data-cuft-cami-btn]');
    var priceEl = card.querySelector('[data-cuft-cami-price]');
    var imgEl = card.querySelector('[data-cuft-cami-img]');

    function renderSizes(color) {
      if (!sizesContainer) return;
      sizesContainer.innerHTML = '';
      selectedSize = null;

      var colorVariants = variants.filter(function (v) { return v.option1 === color; });

      colorVariants.forEach(function (v, idx) {
        var btn = document.createElement('button');
        btn.className = 'cuft-cami-size' + (idx === 0 ? ' cuft-cami-size--active' : '');
        btn.dataset.cuftSize = v.option2;
        btn.dataset.variantId = v.id;
        btn.textContent = v.option2;
        if (!v.available) btn.disabled = true;
        if (idx === 0) selectedSize = v.option2;

        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          sizesContainer.querySelectorAll('.cuft-cami-size').forEach(function (s) {
            s.classList.remove('cuft-cami-size--active');
          });
          btn.classList.add('cuft-cami-size--active');
          selectedSize = btn.dataset.cuftSize;
          updatePrice();
        });

        sizesContainer.appendChild(btn);
      });

      updatePrice();
    }

    function updatePrice() {
      var variant = findVariant();
      if (variant && priceEl) priceEl.textContent = formatMoney(variant.price);
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.option1 === selectedColor && v.option2 === selectedSize;
      });
    }

    function syncToMainProductColor() {
      var mainColor = getCurrentProductColor();
      if (!mainColor) return;

      var matchedColor = variants.find(function (v) {
        return v.option1.toLowerCase() === mainColor.toLowerCase();
      });

      if (matchedColor) {
        selectedColor = matchedColor.option1;
        swatches.forEach(function (s) {
          s.classList.remove('cuft-cami-swatch--active');
          if (s.dataset.cuftColor.toLowerCase() === selectedColor.toLowerCase()) {
            s.classList.add('cuft-cami-swatch--active');
            if (imgEl && s.dataset.cuftImg) imgEl.src = s.dataset.cuftImg;
          }
        });
        renderSizes(selectedColor);
      }
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('cuft-cami-swatch--active'); });
        swatch.classList.add('cuft-cami-swatch--active');
        selectedColor = swatch.dataset.cuftColor;
        if (imgEl && swatch.dataset.cuftImg) imgEl.src = swatch.dataset.cuftImg;
        renderSizes(selectedColor);
      });
    });

    if (btn) {
      btn.addEventListener('click', async function () {
        if (btn.dataset.state === 'adding') return;

        var variant = findVariant();
        if (!variant) {
          alert('Please select a color and size.');
          return;
        }

        btn.dataset.state = 'adding';
        btn.textContent = 'Adding...';

        try {
          var res = await fetch(CART_ADD_API, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: variant.id, quantity: 1 })
          });

          if (!res.ok) throw new Error('Failed to add');

          btn.dataset.state = 'added';
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(refresh, 300);

          setTimeout(function () {
            btn.dataset.state = '';
            btn.textContent = 'Add Cami';
          }, 2000);

        } catch (err) {
          btn.dataset.state = '';
          btn.textContent = 'Add Cami';
        }
      });
    }

    renderSizes(selectedColor);
    syncToMainProductColor();

    document.addEventListener('variant:changed', function (e) {
      syncToMainProductColor();
    });

    var colorInputs = document.querySelectorAll('[name="options[Color]"], [name="options[color]"]');
    colorInputs.forEach(function (input) {
      input.addEventListener('change', syncToMainProductColor);
    });
  }

  function init() {
    refresh();
    bindCartEvents();
    initCamiCard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();